import { Button } from "@sellar-io/components";
import { useMatch, useSearchParams } from "react-router";
import { useSignupContext } from "../../../../../hooks/useSignupContext.shared";
import { SupplierGetResponseType } from "@sellar-io/api-v2/types";
import { STOREFRONT_LINKS_PREVIEW } from "../../../../../constants/routes";
import { useSellarUser } from "../../../../../hooks";
import { useSellarCurrentBusiness } from "../../../../../hooks/useSellarCurrentBusiness.shared";
import { generateSignupContinueUrl } from "../../../../../utils/sellarHelpers";
import { useLocalStorage } from "usehooks-ts";

export const SignUpToAccessBanner = ({
  supplier,
}: {
  supplier?: SupplierGetResponseType;
}) => {
  const isStorefrontLinkPreview = !!useMatch(STOREFRONT_LINKS_PREVIEW);
  const { business } = useSellarCurrentBusiness();
  const { user } = useSellarUser();
  const isLoggedIn = !!business && !!user;
  const [searchParams] = useSearchParams();
  const [, setOnboardingContinueUrl] = useLocalStorage(
    "onboardingContinueUrl",
    "",
  );

  const { setShowLoginTitle, setSignupDialogActive } = useSignupContext();

  const storefrontLink =
    searchParams.get("storefrontLink") || searchParams.get("priceTierLink");

  if (isStorefrontLinkPreview || isLoggedIn) return;

  return (
    <div className="mt-4 flex flex-col items-center gap-4 rounded-lg border border-purple-800 bg-purple-50 p-8">
      <p className="text-center text-lg font-semibold text-zinc-800">
        Sign up to access {supplier?.Business.name}'s trade pricing and order
        from them <u>direct</u>
      </p>
      <Button
        color="purple"
        size="small"
        className="w-[120px]"
        onClick={() => {
          const continueSearchParams = generateSignupContinueUrl(
            supplier?.id,
            storefrontLink ? `storefrontLink=${storefrontLink}` : "",
          );
          setOnboardingContinueUrl(
            `${continueSearchParams.get("continue")}${
              continueSearchParams.get("queryParameters")
                ? `?${continueSearchParams.get("queryParameters")}`
                : ""
            }`,
          );
          setShowLoginTitle(false);
          setSignupDialogActive(true);
        }}
      >
        Sign up
      </Button>
    </div>
  );
};
